import { removeQueryParam } from "@faire/help-center-utils/lib/removeQueryParam";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { ISelfServeBrandOrder } from "@faire/web-api--source/indigofair/helpcenter/ISelfServeBrandOrder";
import { QueryParameters as supportSelfServeParams } from "@faire/web-api--source/routes/www/support/self-serve";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { QueryState } from "../types";
import { setSelectedBrandOrderToLocalStorage } from "../utils/localStorage";

import { useSelfServeContextStore } from "./SelfServeContext";
import { usePaginatedBrandOrders } from "./usePaginatedBrandOrders";
import { useTree } from "./useTree";

export const useExistedBrandOrderEffect = (): QueryState => {
  const { brandOrders, isLoading, dataUpdatedAt } = usePaginatedBrandOrders();
  const { brand_order_token: brandOrderToken } = useQueryParams(
    supportSelfServeParams.parse
  );
  const history = useHistory();
  const location = useLocation();
  const [
    {
      selectedBrandOrder: existingSelectedBrandOrder,
      brandOrders: existingBrandOrders,
    },
    setSelfServeContextStore,
  ] = useSelfServeContextStore(["selectedBrandOrder", "brandOrders"]);
  const { tree } = useTree();

  const brandOrder = brandOrders?.find((brandOrder: ISelfServeBrandOrder) => {
    if (!brandOrder) {
      return false;
    }
    return brandOrder.brand_order?.token === brandOrderToken;
  });

  useEffect(() => {
    if (brandOrderToken && brandOrder && !existingSelectedBrandOrder) {
      setSelfServeContextStore({ selectedBrandOrder: brandOrder });
      setSelectedBrandOrderToLocalStorage(brandOrder);
      removeQueryParam(history, location, "brand_order_token");
    }
  }, [
    history,
    location,
    brandOrder,
    brandOrderToken,
    existingSelectedBrandOrder,
    setSelfServeContextStore,
    tree,
  ]);

  useEffect(() => {
    if (brandOrders && !existingBrandOrders) {
      setSelfServeContextStore({ brandOrders });
    }
  }, [brandOrders, existingBrandOrders, setSelfServeContextStore]);

  return { isLoading, dataUpdatedAt };
};
